import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Q4Page = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [chartVisible, setChartVisible] = useState(false);
  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate('/conclusion');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => setChartVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-user-heart-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">CF 생리학 연구</h1>
                <p className="text-sm text-gray-600">Life 마니또</p>
              </div>
            </Link>
            <nav className="flex items-center space-x-4">
              <Link to="/q3" className="text-gray-600 hover:text-gray-800 whitespace-nowrap">이전</Link>
              <button onClick={handleNextClick} className="text-purple-600 hover:text-purple-800 font-medium whitespace-nowrap">결론</button>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {/* Title Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Q4. 왜 성장이 더디고 학습에 영향이 있을까요?
            </h1>
            <p className="text-xl text-purple-600 font-medium">
              '산소 부족'과 '영양 부족'의 복합적인 결과입니다.
            </p>
          </div>

          {/* Growth Chart Section */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              CF 환자와 정상 아동의 성장 비교
            </h2>
            
            <div className={`transition-all duration-1000 ${chartVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
              <div className="max-w-5xl mx-auto">
                {/* Chart */}
                <div className="relative h-[500px] bg-gray-50 rounded-lg p-8">
                  {/* Grid lines - more detailed */}
                  <div className="absolute left-24 right-8 top-8 bottom-24">
                    {/* Horizontal grid lines */}
                    <div className="absolute left-0 right-0 top-0 h-px bg-gray-300"></div>
                    <div className="absolute left-0 right-0 top-[8.33%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[16.67%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[25%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[33.33%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[41.67%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[50%] h-px bg-gray-300"></div>
                    <div className="absolute left-0 right-0 top-[58.33%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[66.67%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[75%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[83.33%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 top-[91.67%] h-px bg-gray-200"></div>
                    <div className="absolute left-0 right-0 bottom-0 h-px bg-gray-300"></div>
                    
                    {/* Vertical grid lines */}
                    <div className="absolute left-0 top-0 bottom-0 w-px bg-gray-300"></div>
                    <div className="absolute left-[6.25%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[12.5%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[18.75%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[25%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[31.25%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[37.5%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[43.75%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[50%] top-0 bottom-0 w-px bg-gray-300"></div>
                    <div className="absolute left-[56.25%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[62.5%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[68.75%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[75%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[81.25%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[87.5%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute left-[93.75%] top-0 bottom-0 w-px bg-gray-200"></div>
                    <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300"></div>
                  </div>
                  
                  {/* Y-axis */}
                  <div className="absolute left-24 top-8 bottom-24 w-px bg-gray-600"></div>
                  
                  {/* Y-axis labels - more detailed scale (60-180cm) */}
                  <div className="absolute left-2 top-8 text-xs text-gray-700 font-medium">180</div>
                  <div className="absolute left-2 top-[12%] text-xs text-gray-600">170</div>
                  <div className="absolute left-2 top-[20%] text-xs text-gray-600">160</div>
                  <div className="absolute left-2 top-[28%] text-xs text-gray-600">150</div>
                  <div className="absolute left-2 top-[36%] text-xs text-gray-600">140</div>
                  <div className="absolute left-2 top-[44%] text-xs text-gray-600">130</div>
                  <div className="absolute left-2 top-[52%] text-xs text-gray-700 font-medium">120</div>
                  <div className="absolute left-2 top-[60%] text-xs text-gray-600">110</div>
                  <div className="absolute left-2 top-[68%] text-xs text-gray-600">100</div>
                  <div className="absolute left-2 top-[76%] text-xs text-gray-600">90</div>
                  <div className="absolute left-2 top-[84%] text-xs text-gray-600">80</div>
                  <div className="absolute left-2 top-[92%] text-xs text-gray-600">70</div>
                  <div className="absolute left-2 bottom-24 text-xs text-gray-700 font-medium">60</div>
                  
                  {/* Y-axis label */}
                  <div className="absolute left-2 top-2 text-sm font-semibold text-gray-800">
                    평균신장
                    <div className="text-xs text-gray-600 font-normal">(cm)</div>
                  </div>
                  
                  {/* X-axis */}
                  <div className="absolute left-24 right-8 bottom-24 h-px bg-gray-600"></div>
                  
                  {/* X-axis labels - evenly distributed across full width */}
                  <div className="absolute left-24 bottom-20 text-xs text-gray-700 font-medium">0</div>
                  <div className="absolute left-[30%] bottom-20 text-xs text-gray-600">2</div>
                  <div className="absolute left-[36%] bottom-20 text-xs text-gray-600">4</div>
                  <div className="absolute left-[42%] bottom-20 text-xs text-gray-600">6</div>
                  <div className="absolute left-[48%] bottom-20 text-xs text-gray-600">8</div>
                  <div className="absolute left-[54%] bottom-20 text-xs text-gray-700 font-medium">10</div>
                  <div className="absolute left-[60%] bottom-20 text-xs text-gray-600">12</div>
                  <div className="absolute left-[66%] bottom-20 text-xs text-gray-600">14</div>
                  <div className="absolute left-[72%] bottom-20 text-xs text-gray-600">16</div>
                  <div className="absolute left-[78%] bottom-20 text-xs text-gray-600">18</div>
                  <div className="absolute right-8 bottom-20 text-xs text-gray-700 font-medium">20</div>
                  
                  {/* X-axis label */}
                  <div className="absolute left-1/2 bottom-8 transform -translate-x-1/2 text-sm font-semibold text-gray-800">
                    연령 (세)
                  </div>

                  {/* Growth curves - based on CF Foundation data */}
                  {chartVisible && (
                    <>
                      {/* Normal children curve (green) - WHO growth standards */}
                      <svg className="absolute left-24 top-8 w-full h-full" style={{ width: 'calc(100% - 128px)', height: 'calc(100% - 128px)' }}>
                        <polyline
                          fill="none"
                          stroke="#10b981"
                          strokeWidth="3"
                          points="0,360 24,340 48,320 72,300 96,280 120,260 144,220 168,180 192,140 216,120 240,100 264,80 288,60 312,50 336,40"
                          className="animate-draw-line"
                        />
                        {/* Data points for normal children */}
                        <circle cx="0" cy="360" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '0.5s' }} />
                        <circle cx="48" cy="320" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '0.7s' }} />
                        <circle cx="96" cy="280" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '0.9s' }} />
                        <circle cx="144" cy="220" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '1.1s' }} />
                        <circle cx="192" cy="140" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '1.3s' }} />
                        <circle cx="240" cy="100" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '1.5s' }} />
                        <circle cx="288" cy="60" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '1.7s' }} />
                        <circle cx="336" cy="40" r="4" fill="#10b981" className="animate-fade-in" style={{ animationDelay: '1.9s' }} />
                      </svg>
                      
                      {/* CF patients curve (red, dashed) - showing growth delay based on CF Foundation data */}
                      <svg className="absolute left-24 top-8 w-full h-full" style={{ width: 'calc(100% - 128px)', height: 'calc(100% - 128px)' }}>
                        <polyline
                          fill="none"
                          stroke="#ef4444"
                          strokeWidth="3"
                          strokeDasharray="8,4"
                          points="0,380 24,365 48,350 72,335 96,320 120,300 144,270 168,240 192,200 216,170 240,140 264,120 288,100 312,85 336,75"
                          className="animate-draw-line"
                          style={{ animationDelay: '0.3s' }}
                        />
                        {/* Data points for CF patients */}
                        <circle cx="0" cy="380" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '0.8s' }} />
                        <circle cx="48" cy="350" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '1.0s' }} />
                        <circle cx="96" cy="320" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '1.2s' }} />
                        <circle cx="144" cy="270" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '1.4s' }} />
                        <circle cx="192" cy="200" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '1.6s' }} />
                        <circle cx="240" cy="140" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '1.8s' }} />
                        <circle cx="288" cy="100" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '2.0s' }} />
                        <circle cx="336" cy="75" r="4" fill="#ef4444" className="animate-fade-in" style={{ animationDelay: '2.2s' }} />
                      </svg>
                    </>
                  )}
                </div>
                
                {/* Legend */}
                <div className="flex justify-center space-x-8 mt-6">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-1 bg-green-500 rounded"></div>
                    <span className="text-base font-medium text-gray-700">정상 아동</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="relative w-12 h-1">
                      <div className="absolute inset-0 bg-red-500 rounded" style={{ 
                        backgroundImage: 'repeating-linear-gradient(90deg, #EF4444 0px, #EF4444 8px, transparent 8px, transparent 12px)' 
                      }}></div>
                    </div>
                    <span className="text-base font-medium text-gray-700">CF 환자</span>
                  </div>
                </div>
                
                {/* Detailed Statistics - based on CF Foundation data */}
                <div className="mt-8 bg-gray-50 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">주요 성장 지표 비교 (CF Foundation 2021 데이터)</h3>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div>
                      <h4 className="font-medium text-gray-800 mb-2">2세 평균 신장</h4>
                      <div className="space-y-1">
                        <div className="text-green-600 font-medium">정상: 87.5cm</div>
                        <div className="text-red-600 font-medium">CF: 84.2cm</div>
                        <div className="text-xs text-gray-500">차이: -3.3cm</div>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-800 mb-2">6세 평균 신장</h4>
                      <div className="space-y-1">
                        <div className="text-green-600 font-medium">정상: 116.1cm</div>
                        <div className="text-red-600 font-medium">CF: 110.8cm</div>
                        <div className="text-xs text-gray-500">차이: -5.3cm</div>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-800 mb-2">12세 평균 신장</h4>
                      <div className="space-y-1">
                        <div className="text-green-600 font-medium">정상: 151.2cm</div>
                        <div className="text-red-600 font-medium">CF: 143.7cm</div>
                        <div className="text-xs text-gray-500">차이: -7.5cm</div>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-800 mb-2">18세 평균 신장</h4>
                      <div className="space-y-1">
                        <div className="text-green-600 font-medium">정상: 175.3cm</div>
                        <div className="text-red-600 font-medium">CF: 166.8cm</div>
                        <div className="text-xs text-gray-500">차이: -8.5cm</div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 text-center">
                    <div className="text-red-600 font-semibold text-lg">
                      평균 성장 지연: 3-8cm (연령에 따라 증가)
                    </div>
                    <div className="text-sm text-gray-600 mt-2">
                      성장 지연은 영양 흡수 장애와 만성 폐 질환의 복합적 결과
                    </div>
                  </div>
                </div>
                
                {/* Source */}
                <p className="text-xs text-gray-500 text-center mt-6">
                  출처: Cystic Fibrosis Foundation Patient Registry 2021 Annual Data Report
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              이 질문은 앞선 문제들의 결과입니다.
            </h2>

            <div className="space-y-8">
              {/* Problem 1 */}
              <div className="border-l-4 border-orange-500 pl-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <span className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3 text-orange-600 font-bold">1</span>
                  만성적인 영양 결핍 (Q3의 결과)
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  췌장관이 막혀 소화 효소가 나오지 않으면, 음식물을 섭취해도 지방, 단백질 같은 필수 영양소를 분해하고 흡수할 수 없습니다. 
                  성장에 필요한 재료와 에너지가 절대적으로 부족해집니다.
                </p>
              </div>

              {/* Problem 2 */}
              <div className="border-l-4 border-red-500 pl-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <span className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3 text-red-600 font-bold">2</span>
                  만성적인 산소 부족 (Q2의 결과)
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  폐에 점액이 차고 감염이 반복되면(기도 폐쇄, 공기 걸림), 폐가 제 기능을 못 해 몸 전체에 산소를 원활하게 공급하기 어렵습니다. 
                  이는 만성 피로를 유발할 수 있습니다.
                </p>
              </div>
            </div>
          </div>

          {/* Results Section */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-alert-line text-purple-600 mr-3"></i>
              결론
            </h2>
            <p className="text-gray-700 leading-relaxed text-lg">
              이 두 가지 문제(영양 결핍 + 산소 부족)가 복합적으로 작용하여, CF 아동은 또래보다 성장이 더디고 에너지가 부족할 수 있습니다. 
              이는 학교생활에서의 집중력과 학습 능력 저하로 이어질 수 있습니다.
            </p>
          </div>

          {/* Navigation */}
          <div className="flex justify-between items-center">
            <Link 
              to="/q3" 
              className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 px-6 py-3 rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              <span>이전: Q3</span>
            </Link>
            
            <button 
              onClick={handleNextClick}
              className="flex items-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap"
            >
              <span>결론 보기</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Q4Page;
